import "./DocumentDetailSkeleton.scss";

export const DocumentDetailSkeleton = () => {
  return (
    <div className="doc-detail-skeleton-container">
      {/* Document header with title and favorite button */}
      <div className="doc-detail-skeleton-header">
        <div className="doc-detail-skeleton-title-area">
          <div className="doc-detail-skeleton-title pulse"></div>
          <div className="doc-detail-skeleton-label pulse"></div>
        </div>
      </div>

      {/* Details section */}
      <div className="doc-detail-skeleton-section">
        <div className="doc-detail-skeleton-section-header">
          <div className="doc-detail-skeleton-section-title pulse"></div>
          <div className="doc-detail-skeleton-visibility-button pulse"></div>
        </div>

        <div className="doc-detail-skeleton-divider"></div>

        <div className="doc-detail-skeleton-info">
          <div className="doc-detail-skeleton-info-label pulse"></div>
          <div className="doc-detail-skeleton-info-value pulse"></div>
        </div>
      </div>

      {/* Preview section */}
      <div className="doc-detail-skeleton-section">
        <div className="doc-detail-skeleton-section-header">
          <div className="doc-detail-skeleton-section-title pulse"></div>
          <div className="doc-detail-skeleton-download-button pulse"></div>
        </div>

        <div className="doc-detail-skeleton-divider"></div>

        {/* Document preview area */}
        <div className="doc-detail-skeleton-preview pulse"></div>
      </div>
    </div>
  );
};
